import React, { useContext } from "react";
import { Route, Redirect, useLocation } from "react-router-dom";

import { SessionContext } from "../../context/SessionContext";
import { useEffect } from "react";

/* context for hooks */
const PrivateRoute = ({ component: Component, ...rest }) => {
  const { currentSession, setCurrentSession } = useContext(SessionContext);
  const currentLocation = useLocation();

  useEffect(() => {
    setCurrentSession(prevSession => ({
      ...prevSession,
      redirectAfterLogin: currentLocation
    }));
  }, [currentLocation, setCurrentSession]);

  return (
    <Route
      {...rest}
      render={props =>
        currentSession.isLogged ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={
              // TODO: This is a temporary hack to streamline the API trial flow
              currentLocation.pathname === "/api-trial" ? "/signup" : "/login"
            }
          />
        )
      }
    />
  );
};

export default PrivateRoute;
